export interface SapInvoiceFilterParam {
  field: string;
  op: string;
  value: string;
}

export interface SapInvoiceSearchParams {
  indexId: number;
  filters: SapInvoiceFilterParam[];
}

export const parseSapInvoiceSearchParams = (searchParams: URLSearchParams): SapInvoiceSearchParams | null => {
  const indexIdRaw = searchParams.get('IndexId');
  if (indexIdRaw == null || indexIdRaw === '') {
    return null;
  }

  const indexId = Number.parseInt(indexIdRaw, 10);
  if (!Number.isFinite(indexId)) {
    return null;
  }

  const fields = searchParams.getAll('field');
  const operators = searchParams.getAll('op');
  const values = searchParams.getAll('value');

  if (fields.length === 0 || fields.length !== operators.length || fields.length !== values.length) {
    return null;
  }

  const filters: SapInvoiceFilterParam[] = [];
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    const op = operators[i];
    const value = values[i];
    if (!field || !op || value == null || value === '') {
      return null;
    }
    filters.push({ field, op, value });
  }

  return { indexId, filters };
};

export const hasSapInvoiceIndexId = (searchParams: URLSearchParams): boolean => {
  const indexIdRaw = searchParams.get('IndexId');
  return indexIdRaw != null && indexIdRaw !== '';
};
